import {useState} from 'react';
import {useApiQuery} from '@/api';

// fixme: not only use data, some common too - refactor
export const useCurrentUser = () => {
    const [currentUser, setCurrentUser] = useState<apiCurrentUser>({});
    const [globalMessage, setGlobalMessage] = useState('');

    const response: apiResponse | void = useApiQuery('getCurrentUser', {})?.data;
    const responseConfig: apiResponse | void = useApiQuery('getConfig', {})?.data;

    const currentPath = window.location.pathname.split('/')[1];
    const publicPath = ['login', 'request', 'reset-password', 'wiki'];
    const whilteList = ['wiki'];

    if (currentUser.id && publicPath.includes(currentPath) && !whilteList.includes(currentPath)) {
        window.location.pathname = '/welcome';
    }

    if (checkApiResponse(response)) {
        if (response.code === 200) {
            if (!currentUser.id) {
                setCurrentUser(response.data.user);
            }
        } else {
            if (!publicPath.includes(currentPath)) {
                if (currentUser.id) {
                    setCurrentUser({id: ''});
                }

                if (!whilteList.includes(currentPath)) {
                    window.location.pathname = '/login';
                }
            }
        }
    }

    // @ts-ignore
    if (responseConfig && !globalMessage && responseConfig.globalMessage) {
        // @ts-ignore
        setGlobalMessage(responseConfig.globalMessage)
    }

    return {
        currentUser,
        setCurrentUser,
        globalMessage,
        setGlobalMessage,
    };
};

/**
 * is api response correct
 *
 */
const checkApiResponse = (response: apiResponse | void): response is apiResponse => {
    return (response as apiResponse) !== undefined;
};
